import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';

export type TempPayment = {
  order_info: any;
  type: string;
};

const $http = new APIManager();

const Api = {
  /**
   * [POST] Create Payment Temp Data
   * --
   */
  createTempPayment: async (body: TempPayment) => {
    try {
      const res = await $http.post(APIConstant.CREATE_TEMP_PAYMENT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Create Present Temp Data
   * --
   */
  createTempPresent: async (body: TempPayment) => {
    try {
      const res = await $http.multipart(APIConstant.CREATE_TEMP_PRESENT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
